import axios from 'axios'
import router from '@/router'
import store from '@/store'

export const repository = axios.create()
export const baseURL = '/api'
export const adminURL = '/admin-api'
export const fiasURL = '/fias-search'
export const cancelToken = axios.CancelToken

const redirectToLogin = async () => {
  //await store.dispatch('timer/clearInterval')
  await store.dispatch('user/logout')
  if (router.history.current.path !== '/login') await router.replace({ path: '/login' })
  //vm.$toast.warning('Время сессии истекло')
}

repository.interceptors.response.use(undefined, error => {
  if (error.response?.status === 401) {
    router.app._route.name !== 'login' && redirectToLogin()
  }
  return Promise.reject(error.response)
})
